import React, { Fragment } from 'react';
import { filter } from 'lodash';
import enhance from './InfluencerMatchFeed.enhancer';
import Paper from '@material-ui/core/Paper';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import NativeSelectInput from '../../../components/shared/components/NativeSelectInput';
import BootstrapInput from '../../shared/components/OutlinedInputBox';
import { dealStatuses } from '../../../constants';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import LinkText from '../../shared/components/LinkText';
import Dialog from '@material-ui/core/Dialog';

class InfluencerOfferFeed extends React.Component {
  constructor() {
    super();

    this.viewStates = {
      RECIEVED: 'RECIEVED',
      SENT: 'SENT'
    };

    this.initialState = {
      matchOffers: [],
      tableRows: [],
      rowsLoaded: false,
      isPaymentEntryModalOpen: false,
      tableView: this.viewStates.RECIEVED,
      viewStates: [
        {
          key: this.viewStates.RECIEVED,
          value: `Matches I've received`
        },
        {
          key: this.viewStates.SENT,
          value: `Matches I've sent`
        }
      ]
    };

    this.state = {
      ...this.initialState
    };
  }

  componentWillMount() {
    if (this.props.matchesPending) {
      this.loadData(this.props.matchesPending);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.matchesPending && nextProps.matchesPending.length) {
      this.loadData(nextProps.matchesPending);
    }
  }

  loadData(pendingMatches) {
    const offeredDeals = filter(
      pendingMatches,
      mp => mp.status === dealStatuses.OFFER
    );
    let requests = offeredDeals.map(deal => {
      return new Promise(resolve => {
        //get user data
        this.props.firestore
          .get({
            collection: 'users',
            doc: deal.companyId
          })
          .then(user => {
            if (user && deal.companyId) {
              const userData = user.data();
              if (userData) {
                deal.companyName = userData.displayName;
                deal.picUrl = userData.profilePictureUrl;
                deal.companyId = user.id;
              }
            }

            //get campaign data
            this.props.firestore
              .get({
                collection: 'campaigns',
                storeAs: 'influencerMatchFeedCampaign',
                doc: deal.campaignId
              })
              .then(camp => {
                if (camp && deal.campaignId) {
                  const campData = camp.data();
                  if (campData) {
                    deal.campaign = campData;
                  }
                }
                resolve(deal);
              });
          });
      });
    });

    Promise.all(requests).then(deals => {
      this.setState({
        matchOffers: deals
      });
      this.filterDeals(this.state.tableView);
    });
  }

  filterDeals(tableState) {
    const filteredOffers = filter(this.state.matchOffers, offer =>
      tableState === 'RECIEVED'
        ? offer.initiator === 'company'
        : offer.initiator === 'influencer'
    );

    this.setState({
      tableRows: filteredOffers,
      rowsLoaded: true
    });
  }

  viewSelectChangeHandler(e) {
    this.setState(
      {
        tableView: e.target.value
      },
      this.filterDeals(e.target.value)
    );
  }

  acceptMatch(row) {
    if (
      this.props.profile.paypalInfo &&
      this.props.profile.paypalInfo.payerId
    ) {
      const acceptedMatch = {
        deal: row,
        initiator: this.props.auth.uid
      };
      this.props.acceptMatchHandler(acceptedMatch);
    } else {
      this.setState({
        isPaymentEntryModalOpen: true
      });
    }
  }

  rejectMatch(row) {
    const rejectedMatch = {
      deal: row,
      initiator: row.companyId
    };
    this.props.rejectMatchHandler(rejectedMatch);
  }

  navigateToCampaign(campaignId) {
    this.props.history.push(`/campaigns/${campaignId}`);
  }

  navigateToProfile(userId) {
    this.props.history.push(`/user/${userId}/profile`);
  }

  navigateToSettings() {
    this.props.history.push(`/settings`);
  }

  handleClosePaymentModal() {
    this.setState({
      isPaymentEntryModalOpen: false
    });
  }

  render() {
    const { classes } = this.props;
    const { tableRows, rowsLoaded, tableView, viewStates } = this.state;

    return (
      <React.Fragment>
        <main className={classes.layout}>
          <div className={classes.title}>
            <Typography variant="h3" id="tableTitle" className={classes.title}>
              Match Feed
            </Typography>
          </div>
          <div>
            <TextField
              id="viewSelect"
              name="viewSelect"
              select
              className={classes.select}
              SelectProps={{
                MenuProps: {
                  className: classes.selectMenu
                }
              }}
              margin="normal"
              variant="outlined"
              onChange={this.viewSelectChangeHandler.bind(this)}
              value={tableView}
            >
              {viewStates.map((item, i) => (
                <MenuItem key={i} value={item.key}>
                  {item.value}
                </MenuItem>
              ))}
            </TextField>
          </div>
          {tableRows &&
            rowsLoaded &&
            tableRows.map(row => (
              <Paper className={classes.root}>
                <Grid container alignItems="center" spacing={2}>
                  <Grid item sm={4} container alignItems="center">
                    <img src={row.picUrl} className={classes.circleImage} />
                    <LinkText
                      variant="h6"
                      onClick={() => this.navigateToProfile(row.companyId)}
                      className={classes.companyName}
                    >
                      {row.companyName}
                    </LinkText>
                  </Grid>
                  <Grid item sm={4}>
                    <LinkText
                      variant="h6"
                      className={classes.linkStyle}
                      onClick={() => this.navigateToCampaign(row.campaignId)}
                    >
                      {row.campaign ? row.campaign.name : ''}
                    </LinkText>
                  </Grid>
                  <Grid
                    item
                    sm={4}
                    container
                    alignItems="center"
                    justify="flex-end"
                    spacing={2}
                  >
                    {tableView === 'RECIEVED' && (
                      <Fragment>
                        <Grid item>
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.acceptButton}
                            onClick={() => this.acceptMatch(row)}
                          >
                            Accept
                          </Button>
                        </Grid>
                        <Grid item>
                          <Button
                            variant="outlined"
                            color="secondary"
                            className={classes.rejectButton}
                            onClick={() => this.rejectMatch(row)}
                          >
                            Reject
                          </Button>
                        </Grid>
                      </Fragment>
                    )}
                    {tableView === 'SENT' && (
                      <div>
                        <Button variant="outlined" color="primary">
                          Pending
                        </Button>
                      </div>
                    )}
                  </Grid>
                </Grid>
              </Paper>
            ))}
          {!tableRows.length && rowsLoaded && (
            <Paper className={classes.root} className={classes.noCurrentOffers}>
              <Grid container direction="row" justify="center">
                <Grid
                  container
                  alignItems="center"
                  sm={12}
                  justify="center"
                  className={classes.noOffersContainer}
                >
                  <Typography variant="h6" align="center">
                    No current offers.
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          )}
        </main>
        <Dialog
          id="payment-info-dialog"
          open={this.state.isPaymentEntryModalOpen}
          onClose={this.props.handleClose}
          disableAutoFocus={true}
          onBackdropClick={this.handleClosePaymentModal.bind(this)}
          PaperProps={{
            style: {
              minHeight: '150px',
              minWidth: '350px',
              padding: '20px'
            }
          }}
        >
          <Typography variant="h6" align="center" justify="center">
            Set up your payment info before accepting an invite!
          </Typography>
          <Typography variant="body1" align="center" justify="center">
            <Button
              variant="contained"
              color="primary"
              className={classes.paymentButton}
              onClick={this.navigateToSettings.bind(this)}
            >
              Payment Settings
            </Button>
          </Typography>
        </Dialog>
      </React.Fragment>
    );
  }
}

InfluencerOfferFeed.propTypes = {
  matchOffers: PropTypes.array
};

export default enhance(InfluencerOfferFeed);



// WEBPACK FOOTER //
// ./src/components/influencer/match-feed/InfluencerMatchFeed.js